(function () {
  function init(root) {
    if (!root || root.dataset.dphReady) return;
    root.dataset.dphReady = '1';

    var drawer = root.querySelector('[data-dph-drawer]');
    var burger = root.querySelector('[data-dph-open]');
    var search = root.querySelector('[data-dph-search]');
    var searchBtn = root.querySelector('[data-dph-search-open]');
    var lastFocus = null;

    // ----- sticky shadow -----
    function onScroll() {
      root.classList.toggle('is-scrolled', window.scrollY > 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ----- desktop menu fit -----
    // Same sizes as drmelaxin.uk (14px text, 10px side padding, 20px promo spacer) whenever they fit;
    // otherwise drop the spacer, then tighten padding, then text size, so the icons never leave the screen.
    var nav = root.querySelector('.dph__nav');
    var menu = root.querySelector('.dph__menu');
    var desktopMq = window.matchMedia('(min-width: 1280px)');
    function fits() { return menu.scrollWidth <= nav.clientWidth + 0.5; }
    function fitMenu() {
      if (!nav || !menu) return;
      root.style.removeProperty('--dph-menu-size');
      root.style.removeProperty('--dph-item-pad');
      root.classList.add('has-room');
      if (!desktopMq.matches) return;
      if (fits()) return;
      root.classList.remove('has-room');
      var pad = 10;
      while (!fits() && pad > 8) { pad -= 1; root.style.setProperty('--dph-item-pad', pad + 'px'); }
      var size = 14;
      while (!fits() && size > 12) { size -= 0.25; root.style.setProperty('--dph-menu-size', size + 'px'); }
      while (!fits() && pad > 3) { pad -= 1; root.style.setProperty('--dph-item-pad', pad + 'px'); }
      while (!fits() && size > 11) { size -= 0.25; root.style.setProperty('--dph-menu-size', size + 'px'); }
    }
    fitMenu();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMenu);
    var fitTimer;
    window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(fitMenu, 100); });

    // ----- drawer -----
    function closeSubs() {
      root.querySelectorAll('.dph__mitem.is-open').forEach(function (li) {
        li.classList.remove('is-open');
        var b = li.querySelector('[data-dph-sub-open]');
        if (b) b.setAttribute('aria-expanded', 'false');
        var s = li.querySelector('.dph__sub');
        if (s) s.setAttribute('aria-hidden', 'true');
      });
      if (drawer) drawer.classList.remove('has-sub');
    }
    function openDrawer() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      document.body.classList.add('dph-lock');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      var close = drawer.querySelector('[data-dph-close]');
      if (close) setTimeout(function () { close.focus(); }, 50);
    }
    function closeDrawer() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      document.body.classList.remove('dph-lock');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(closeSubs, 500);
      if (lastFocus) lastFocus.focus();
    }
    if (burger && drawer) {
      burger.addEventListener('click', openDrawer);
      root.querySelectorAll('[data-dph-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      root.querySelectorAll('[data-dph-sub-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var li = btn.closest('.dph__mitem');
          li.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          li.querySelector('.dph__sub').setAttribute('aria-hidden', 'false');
          var body = drawer.querySelector('.dph__drawer-body');
          if (body) body.scrollTop = 0;
          drawer.classList.add('has-sub');
          var back = li.querySelector('[data-dph-sub-close]');
          if (back) setTimeout(function () { back.focus(); }, 300);
        });
      });
      root.querySelectorAll('[data-dph-sub-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var li = btn.closest('.dph__mitem');
          closeSubs();
          var opener = li.querySelector('[data-dph-sub-open]');
          if (opener) opener.focus();
        });
      });
      // wishlist link inside the drawer opens the theme's wishlist drawer — close ours first
      drawer.querySelectorAll('a[href="#lumin-wishlist-drawer"]').forEach(function (a) {
        a.addEventListener('click', closeDrawer);
      });
    }

    // ----- search -----
    function openSearch() {
      lastFocus = document.activeElement;
      search.hidden = false;
      searchBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('dph-lock');
      var input = search.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
    function closeSearch() {
      if (search.hidden) return;
      search.hidden = true;
      searchBtn.setAttribute('aria-expanded', 'false');
      if (!root.classList.contains('is-open')) document.body.classList.remove('dph-lock');
      if (lastFocus) lastFocus.focus();
    }
    if (search && searchBtn) {
      searchBtn.addEventListener('click', openSearch);
      search.querySelectorAll('[data-dph-search-close]').forEach(function (el) {
        el.addEventListener('click', closeSearch);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (search && !search.hidden) closeSearch();
      else closeDrawer();
    });

    // leaving phone layout with the drawer open should not keep the page locked
    var mq = window.matchMedia('(min-width: 1280px)');
    var onChange = function () { if (mq.matches) closeDrawer(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
  }

  document.querySelectorAll('[data-dph]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-dph]').forEach(init);
  });
})();
